import { useEffect, useState } from 'react';

export default function useOrganizations(api) {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        api('/organizations/options')
            .then((items) => {
                if (active) setOrganizations(items);
            })
            .catch((requestError) => {
                if (active) setError(requestError.message);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [api]);

    return { organizations, loading, error };
}
